import { render, staticRenderFns } from "./IntegrationsList.vue?vue&type=template&id=253139c8&scoped=true&"
import script from "./IntegrationsList.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253139c8",
  null
  
)

export default component.exports